import { Handle, Position, type NodeProps } from '@xyflow/react'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import { Bot } from 'lucide-react'
import type { FlowNode } from '@/schemas/workflow-node'
import { NeedsAttentionBadge } from '@/components/workflows/lifecycle/needs-attention-badge'

export function AgentNode({ data, selected }: NodeProps) {
  const nodeData = data as unknown as FlowNode
  const needsAttention =
    (data as unknown as { needs_attention?: boolean })?.needs_attention === true
  const agentId = (nodeData.config as { agent_id?: string })?.agent_id

  return (
    <div
      className={cn(
        'relative rounded-xl border border-border bg-card p-4 min-w-[220px] shadow-sm',
        'border-l-4 border-l-purple-500',
        needsAttention && 'border-amber-500 border-2',
        selected && 'ring-2 ring-primary'
      )}
    >
      {needsAttention && (
        <div className="absolute top-1 right-1">
          <NeedsAttentionBadge />
        </div>
      )}
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-primary !w-3 !h-3"
      />
      <div className="flex items-center gap-1 mb-1">
        <Bot className="w-4 h-4 text-purple-500" />
        <Badge variant="outline" className="text-xs">
          Agent
        </Badge>
      </div>
      <div className="text-sm font-semibold text-foreground truncate">
        {nodeData.label || 'Agent Node'}
      </div>
      <div className="text-xs text-muted-foreground truncate mt-0.5">
        {agentId ? agentId.slice(0, 12) + '...' : 'No agent set'}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-primary !w-3 !h-3"
      />
    </div>
  )
}
